import styled from "styled-components"

export const MenuWrapper = styled.div`
  width: 290px;
`
